import * as React from 'react';
import { iconMap } from '../get-icon-by-name.js';
import Icon from '../Icon/Icon.js';

const FeatureIcon = ({ name , size =24  })=>{
    const source = iconMap[name];
    if (!source) {
        console.warn(`There is no icon with name '${name}'`);
        return /*#__PURE__*/ React.createElement("span", null, "No icon found with name ", name);
    }
    return /*#__PURE__*/ React.createElement(Icon, {
        name: name,
        width: size,
        height: size,
        viewBox: "0 0 40 40"
    });
};

export { FeatureIcon as default };
//# sourceMappingURL=FeatureIcon.js.map
